import { render } from "./itemProduct.vue?vue&type=template&id=458e609d"
import script from "./itemProduct.vue?vue&type=script&lang=js"
export * from "./itemProduct.vue?vue&type=script&lang=js"

import "./itemProduct.vue?vue&type=style&index=0&id=458e609d&lang=stylus"
import "./itemProduct.vue?vue&type=style&index=1&id=458e609d&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__